var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-btn-box"},[_c('v-btn',{staticClass:"site-btn",on:{"btnClick":_vm.on_click}},[_vm._v(" "+_vm._s(_vm.$TL.goTopic)+" "),_c('v-icon',[_vm._v("chevron_right")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }